import {reduxForm} from 'redux-form';
import {AcceptorsFilterForm} from '../../shared/components/acceptorsFilter/model';
import {Forms} from '../../shared/models/forms';
import View from './view';

const DecoratedView = reduxForm<AcceptorsFilterForm, {}>({
  form: Forms.acceptorsFilterForm,
  destroyOnUnmount: false,
})(View);

export const acceptorsFilterScreen = DecoratedView;
